import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import ProductoRow, { valorAjuste } from "./ProductoRow";
import { money } from "../../../utils/helpers";
import Loader from "../../general/Loader";
import NewFileLoader from "../../general/NewFileLoader";
import ManualPagination from "../../general/ManualPagination";

const Form = ({movimiento = {}, items, loadingItems, onSave, onCancel, errors = {}, categorias = []}) => {
    const perPage = 30;
    const [loading, setLoading] = useState(false);
    const [productos, setProductos] = useState(movimiento.productos?.map(p => ({ _key: crypto.randomUUID(), ...p})) ?? []);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(Math.ceil((productos?.length ?? 0) / perPage));
    const [filter, setFilter] = useState({ categorias : [] });
    const [shows, setShows] = useState(productos.slice(0, 30).map(p => p._key));
    const [offset, setOffset] = useState(0);
    const [count, setCount] = useState(productos.length);
    const valorTotal = productos.reduce((total, p) => total + valorAjuste(p, items?.find(i => i.id === p.producto_id)), 0);

    const nextPage = () => setPage(Math.min(page + 1, totalPage));
    const previewPage = () => setPage(Math.max(page - 1, 1));

    const agregarProducto = () => {
        setProductos([...productos, {_key: crypto.randomUUID()}]);
    };

    const agregarTodoProducto = () => {
        setProductos([...productos.filter(p => !!p.producto_id), ...items.filter(i => !productos.find(p => p.producto_id === i.id)).map(i => ({ producto_id: i.id, _key: crypto.randomUUID() }))])
    };

    const updateProducto = (index, producto) => {
        setProductos([...productos.map((p, i) => i === index ? producto : p)])
    }

    const removerProducto = (index) => {
        setProductos([...productos.filter((p,  i) => i !== index)]);
    };

    const submit = async (e) => {
        e.preventDefault();

        setLoading(true);

        await onSave(e);

        setLoading(false);
    };

    useEffect(() => { 
        const filtered = filter.categorias.length ? productos.filter(p => {
            return filter.categorias.find(c => {
                return c.value === p.producto?.grupo?.id;
            });
        }) : [...productos];
        const total = Math.ceil((filtered.length ?? 0) / perPage);
        const pg = Math.max(Math.min(page, total), 1);

        const start = (pg - 1) * perPage;
        const end = start + perPage;
        const keys = filtered.slice(start, end).map(p => p._key);

        setTotalPage(total);
        setPage(pg);
        setOffset(0);
        setCount(filtered.length);
        setShows(keys);
    }, [filter, page, productos])

    useEffect(() => {
        setPage(Math.max(Math.min(page, totalPage), 1));
    }, [totalPage]);


    return <form onSubmit={submit}>
        <div className="card px-3 py-4 pretty-form" style={{backgroundColor: '#f7f7f7', borderRadius: '10px'}}>
            <div className="row">
                <div className="col-12 col-md-3 form-group pr-0">
                    <label className="required" htmlFor="fecha">Fecha</label>
                    <input type="date" className="form-control" id="fecha" name="fecha" defaultValue={dayjs(movimiento.fecha).format('YYYY-MM-DD')}/>
                    {errors.fecha && (
                        <small className="help-blockParams form-Text">
                            {errors.fecha[0]}
                        </small>
                    )}
                </div>
                <div className="col-12 col-md-3 form-group pr-0">
                    <label className="required" htmlFor="titulo">Título del inventario</label>
                    <input type="text" className="form-control" id="titulo" name="titulo" defaultValue={movimiento.titulo} placeholder="Título"/>
                    {errors.titulo && (
                        <small className="help-blockParams form-Text">
                            {errors.titulo[0]}
                        </small>
                    )}
                </div>
                
                <div className="col-12 col-md-3 form-group pr-0">
                    <label className="required" htmlFor="titulo">Filtra por Categorías</label>
                    <Select isMulti={true} options={categorias} onChange={e => setFilter({ ...filter, categorias: e ?? [] })} />
                </div>

                {loadingItems && <button type="button" className="btn mt-4 mb-3 mx-2 tooltip-self" disabled>
                    <div className='small-loader lds-dual-ring' style={{width: '16px', height: '16px', display: "inline-block"}} />
                    
                    <span className="tootip-text tooltip-top tooltip-sm">Cargando<br/>los productos</span>
                </button>}
                {!loading && !loadingItems && !!items && !!items.length && items.length > productos.length && <button type="button" className="btn btn-info mt-4 mb-3 mx-2 tooltip-self" onClick={agregarTodoProducto}>
                    <i className="zmdi zmdi-collection-plus"></i>
                    
                    <span className="tootip-text tooltip-top tooltip-sm">Agregar todos<br/>los productos</span>
                </button>}
            </div>

            <div className="row">
                <div className="col-12">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th style={{textAlign: 'left'}}>REF./CÓDIGO</th>
                                <th style={{textAlign: 'left'}}>PRODUCTO</th>
                                <th>EN INVENTARIO</th>
                                <th>TIPO DE AJUSTE</th>
                                <th>CANT. (UNIDAD BASE)</th>
                                <th>MOTIVO</th>
                                <th>NUEVA</th>
                                <th>VALOR</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {productos.map((producto, index) => <ProductoRow key={producto._key} index={index} items={items} producto={producto} offset={offset} productos={productos} errors={errors} remover={removerProducto} setProducto={updateProducto} show={shows.find(key => key === producto._key)} />)}
                        </tbody>

                        <tfoot>
                            <tr>
                                <td colSpan={10}>
                                    <ManualPagination current={page} per={perPage} total={count} prev={previewPage} next={nextPage} />
                                </td>
                            </tr>
                            {productos.length > 0 && <tr>
                                <td colSpan={8} className="text-right"><strong>TOTAL</strong></td>
                                <td className={`text-right${valorTotal < 0 ? ' text-danger' : ''}`}><strong>{money(valorTotal)}</strong></td>
                                <td></td>
                            </tr>}
                            <tr>
                                <td colSpan={9} style={{border: "0px"}}>
                                    {!loading && items && items.length && items.length > productos.length
                                        ? <button type="button" className="btn btn-outline-primary px-3 py-2 mx-2 d-flex" style={{borderStyle: 'dashed'}} onClick={agregarProducto}>
                                            <i className="zmdi zmdi-plus mr-2 my-auto" style={{fontSize: '1.25rem'}}></i> <strong className="mt-auto" style={{fontWeight: 500}}>Agregar Producto</strong>
                                        </button>
                                        : <small>{loadingItems ? 'Cargando productos...' : 'Todos los productos agregados'}</small>}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col12 col-md-6 form-group">
                    <label htmlFor="adjunto" className="label form-control-label">Adjuntos</label>

                    <NewFileLoader
                        name="adjuntos[]"
                        archivos={movimiento.adjuntos ?? []}
                    />
                    {errors.adjuntos && (
                        <small className="help-blockParams form-Text">
                            {errors.adjuntos[0]}
                        </small>
                    )}
                </div>

                <div className="col12 col-md-6 form-group">
                    <label htmlFor="notas" className="label form-control-label">Notas</label>
                    <textarea className="text-input form-control" name="notas" rows={5} defaultValue={movimiento.notas} />
                    {errors.notas && (
                        <small className="help-blockParams form-Text">
                            {errors.notas[0]}
                        </small>
                    )}
                </div>
            </div>
        </div>

        <div className="row mt-4">
            {loading ? <Loader className="ml-auto mr-1" type="small" /> : <>
                <button type="button" className="btn btn-secondary ml-1 mr-auto btn-pretty" onClick={onCancel}>
                    <i className="fas fa-times mx-2"></i>
                    <strong style={{fontWeight: 500}}>Descartar</strong>
                </button>
            
                <button type="submit" className="btn btn-primary ml-auto mx-1 btn-pretty">
                    <i className="far fa-save mx-2"></i>
                    <strong style={{fontWeight: 500}}>Guardar ajuste</strong>
                </button>
            </>}
        </div>
    </form>;
};

export default Form;
